import { render, staticRenderFns } from "./ManFacter.vue?vue&type=template&id=e2cad0c2&scoped=true"
import script from "./ManFacter.vue?vue&type=script&lang=js"
export * from "./ManFacter.vue?vue&type=script&lang=js"
import style0 from "./ManFacter.vue?vue&type=style&index=0&id=e2cad0c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cad0c2",
  null
  
)

export default component.exports